import DeleteDealershipForm from './DeleteDealershipForm';

export default DeleteDealershipForm;
